import React from 'react';
import PropTypes from 'prop-types';
import Select2 from '../Select2.jsx';

function humanize(name) {
  return name.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

// Stable reference so Select2 doesn't re-init on every parent render.
const SELECT2_OPTIONS = { minimumResultsForSearch: Infinity };

class LogoTab extends React.Component {
  constructor(props) {
    super(props);
    // Built once — a fresh array each render makes Select2 loop (see QrStyleForm).
    // The `none` clip means an unclipped (square) logo backing, so it reads as "Square"
    // in the buffer-zone picker while keeping the `none` enum value on the wire.
    this.clipData = props.logoClips.map((clip) => ({
      id: clip,
      text: clip === 'none' ? 'Square' : humanize(clip),
    }));
  }

  render() {
    const {
      style, patchStyle, onLogoFile, uploadError,
    } = this.props;
    return (
      <div className="qr-logo-tab">
        <div className="qr-field">
          <label className="qr-label">Logo image</label>
          {/* No `name` — this never submits raw bytes. onChange lifts the picked
              File so QrStyleForm can upload it and submit the resulting signed id
              via a hidden field instead. */}
          <input
            type="file"
            accept="image/png"
            className="qr-file"
            data-testid="logo-file"
            onChange={(e) => onLogoFile(e.target.files[0] || null)}
          />
          <p className="qr-help">
            PNG, ≤5MB. The preview updates with your logo once it finishes uploading.
          </p>
          {uploadError && (
            <p className="qr-help" data-testid="logo-upload-error" style={{ color: '#a94442' }}>
              Upload failed — pick the file again to retry.
            </p>
          )}
        </div>

        <div className="qr-row-head qr-row-head--spaced">
          <span className="qr-row-title">Hide background dots</span>
          <label className="qr-inline-check">
            <input
              type="checkbox"
              data-testid="remove-bg"
              checked={!!style.logo_remove_background}
              onChange={(e) => patchStyle('logo_remove_background', e.target.checked)}
            />
          </label>
        </div>

        <div className="qr-field">
          <label className="qr-label qr-label--inline">
            <span>Logo size</span>
            <span className="qr-range-value">{`${Math.round(style.logo_size_ratio * 100)}%`}</span>
          </label>
          <input
            type="range"
            className="qr-range"
            min="0.05"
            max="0.5"
            step="0.05"
            data-testid="logo-size"
            value={style.logo_size_ratio}
            onChange={(e) => patchStyle('logo_size_ratio', parseFloat(e.target.value))}
          />
        </div>

        <div className="qr-field">
          <label className="qr-label">Logo buffer zone</label>
          <Select2
            className="form-control"
            data-testid="logo-clip"
            value={style.logo_clip}
            data={this.clipData}
            options={SELECT2_OPTIONS}
            onChange={(e) => patchStyle('logo_clip', e.target.value)}
          />
        </div>
      </div>
    );
  }
}

LogoTab.propTypes = {
  style: PropTypes.object.isRequired,
  patchStyle: PropTypes.func.isRequired,
  logoClips: PropTypes.arrayOf(PropTypes.string).isRequired,
  onLogoFile: PropTypes.func,
  uploadError: PropTypes.bool,
};

LogoTab.defaultProps = { onLogoFile: () => {}, uploadError: false };

export default LogoTab;
